<h2 mat-dialog-title>CSV bestand geupload</h2>
<mat-dialog-content>
  <p>De verhalen zijn succesvol ingelezen en nu te bewerken, publiceren in het CMS.</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" mat-dialog-close cdkFocusInitial>Ok</button>
</mat-dialog-actions>
